var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0",
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus,
            bundle:
              _vm.flowType === "bundle" ||
              _vm.flowType === "cabundle" ||
              _vm.flowType === "rabundle"
          },
          attrs: { role: "main" }
        },
        [
          _c(
            "form",
            {
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.submitted($event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "container-fluid px-0",
                  attrs: { id: "form-container" }
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "row mx-0 bg-white",
                        attrs: { id: "form-headings" }
                      },
                      [
                        _c("div", { staticClass: "col-12 text-left px-0" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _vm.blurbs.formtop.visible
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mx-auto mb-1"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "alert alert-primary my-0 py-2 w-50",
                                      attrs: { role: "note" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row no-gutters" },
                                        [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "col d-inline-block my-auto smaller-font-content",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.blurbs.formtop.content
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mx-0" }, [
                            _c("div", { staticClass: "col-12 px-0" }, [
                              this.pageData.polk_buttons &&
                              this.pageData.polk_buttons.length
                                ? _c(
                                    "div",
                                    { staticClass: "row no-gutters mt-1 mb-3" },
                                    [
                                      _vm._m(2),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 py-2 shadow-sm rounded-bottom"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-inline-block w-100"
                                            },
                                            _vm._l(
                                              _vm.pageData.polk_buttons,
                                              function(pItem, pKey) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: pKey + "_polk_btn",
                                                    staticClass:
                                                      "polk-btns vd-btn btn px-3 wsn list-item",
                                                    class: {
                                                      "select complete":
                                                        pItem.status ===
                                                        "Included",
                                                      deselect:
                                                        pItem.status ===
                                                        "Excluded"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "polk_vehicle_" + pKey,
                                                      tabindex: "0"
                                                    },
                                                    on: {
                                                      keydown: function(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        $event.preventDefault()
                                                        $event.stopPropagation()
                                                        return _vm.updatePolkData(
                                                          pItem,
                                                          "vehicle"
                                                        )
                                                      },
                                                      click: function($event) {
                                                        return _vm.updatePolkData(
                                                          pItem,
                                                          "vehicle"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("icon", {
                                                          staticClass:
                                                            "d-block mx-auto float-left",
                                                          attrs: {
                                                            name: "car",
                                                            scale: "1.1"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "polk-veh-lbl float-left text-left d-block pl-1"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                pItem.label
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        pItem.status ===
                                                        "IncludedComplete"
                                                          ? _c("div", {
                                                              staticClass:
                                                                "vehicle-check-polk"
                                                            })
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row no-gutters mt-1" },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 py-2 shadow-sm rounded-bottom"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-inline-block w-100" },
                                        [
                                          _vm._l(
                                            _vm.pageData.new_buttons,
                                            function(ndData, ndKey) {
                                              return [
                                                ndData.name !== "AddVehicle"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        key:
                                                          ndKey +
                                                          "_non_add_veh",
                                                        staticClass:
                                                          "vd-btn btn px-3 wsn select list-item",
                                                        attrs: { tabindex: "0" }
                                                      },
                                                      [
                                                        _c("icon", {
                                                          staticClass:
                                                            "d-block mx-auto float-left",
                                                          attrs: {
                                                            name: "car",
                                                            scale: "1.1"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "smaller-font-content polk-veh-lbl float-left text-left d-block pl-1"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  ndData.label
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.$store.state
                                                          .buttonState
                                                          .quoteSummaryData &&
                                                        _vm.$store.state
                                                          .buttonState
                                                          .quoteSummaryData
                                                          .quote_status !==
                                                          "Bound"
                                                          ? _c("a", {
                                                              staticClass:
                                                                "delete",
                                                              attrs: {
                                                                href:
                                                                  "JavaScript:void(0);",
                                                                "aria-label":
                                                                  "remove vehicle",
                                                                tabindex: "0"
                                                              },
                                                              on: {
                                                                keydown: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    !$event.type.indexOf(
                                                                      "key"
                                                                    ) &&
                                                                    _vm._k(
                                                                      $event.keyCode,
                                                                      "enter",
                                                                      13,
                                                                      $event.key,
                                                                      "Enter"
                                                                    )
                                                                  ) {
                                                                    return null
                                                                  }
                                                                  $event.preventDefault()
                                                                  $event.stopPropagation()
                                                                  return _vm.openRemoveModal(
                                                                    "remove-vehicle-modal",
                                                                    ndData.on_click
                                                                  )
                                                                },
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.openRemoveModal(
                                                                    "remove-vehicle-modal",
                                                                    ndData.on_click
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        ndData.status ===
                                                        "IncludedComplete"
                                                          ? _c("div", {
                                                              staticClass:
                                                                "check"
                                                            })
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                ndData.name === "AddVehicle" &&
                                                ndData.status !== "Invisible" &&
                                                _vm.$store.state.buttonState
                                                  .quoteSummaryData &&
                                                _vm.$store.state.buttonState
                                                  .quoteSummaryData
                                                  .quote_status !== "Bound"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        key: ndKey + "_veh_add",
                                                        staticClass:
                                                          "add-button btn btn-outline-success px-1 wsn select list-item px-3",
                                                        attrs: {
                                                          tabindex: "0"
                                                        },
                                                        on: {
                                                          keydown: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                            return _vm.addNewRule(
                                                              ndData,
                                                              "Vehicle"
                                                            )
                                                          },
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.addNewRule(
                                                              ndData,
                                                              "Vehicle"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("icon", {
                                                          staticClass:
                                                            "d-block mx-auto float-left",
                                                          attrs: {
                                                            name: "plus-circle",
                                                            scale: "1.1"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "smaller-font-content polk-veh-lbl float-left text-left d-block pl-1"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  ndData.label
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "scrolling-wrapper pb-2 bg-white",
                        attrs: { id: "carousel-vehicle-top-scrollbar" }
                      },
                      _vm._l(_vm.pageFieldsArray, function(vitem, vkey) {
                        return _c("div", {
                          key: vkey + "_veh_cnt",
                          staticClass: "cardItem col-md-3"
                        })
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "scrolling-wrapper pt-3 bg-white",
                        attrs: { id: "carousel-vehicle-headings" }
                      },
                      _vm._l(_vm.pageFieldsArray, function(vitem, vkey) {
                        return _c(
                          "div",
                          {
                            key: vkey + "_veh_cnt",
                            staticClass: "cardItem col-md-3"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row py-2 pl-3 mx-0 bg-ltblue text-white rounded-top h-100",
                                attrs: { id: "vehAcc_" + vkey }
                              },
                              [
                                _c("div", { staticClass: "col p-0" }, [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        attrs: {
                                          role: "heading",
                                          "aria-level": "3"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getAccordianLabel(
                                              _vm.pageFieldsArray,
                                              vkey
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.$store.state.buttonState
                                      .quoteSummaryData &&
                                    _vm.$store.state.buttonState
                                      .quoteSummaryData.quote_status !== "Bound"
                                      ? _c("a", {
                                          staticClass: "delete",
                                          attrs: {
                                            href: "JavaScript:void(0);",
                                            "aria-label": "remove vehicle"
                                          },
                                          on: {
                                            keydown: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.openRemoveModal(
                                                "remove-vehicle-modal",
                                                _vm.deleteLinks[vkey].on_click
                                              )
                                            },
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.openRemoveModal(
                                                "remove-vehicle-modal",
                                                _vm.deleteLinks[vkey].on_click
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container-fluid",
                  staticStyle: { "margin-top": "0" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row scrolling-wrapper pb-3",
                      attrs: { id: "carousel-vehicle" }
                    },
                    _vm._l(_vm.pageFieldsArray, function(vitem, vkey) {
                      return _c(
                        "div",
                        {
                          key: vkey + "_veh_cnt",
                          staticClass: "cardItem col-md-3 mb-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row mx-0 pt-3 accordPanel shadow-sm rounded-bottom",
                              attrs: { id: "vehAccPanel_" + vkey }
                            },
                            [
                              _c("div", { staticClass: "col-12 px-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-row ml-3 mr-0" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 px-0" },
                                      _vm._l(vitem, function(subItem, subKey) {
                                        return _c(
                                          "form-block",
                                          {
                                            key: subKey + "_veh_fld_cnt",
                                            ref: subItem.field_name,
                                            refInFor: true,
                                            staticClass: "form-group",
                                            attrs: {
                                              formdata: subItem,
                                              formIndex: vkey
                                            }
                                          },
                                          [
                                            _vm.getSubsectionDisplayStatus(
                                              subItem,
                                              subKey,
                                              vitem,
                                              vkey
                                            )
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-row mx-0"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col py-1 pl-2 my-2 ml-0 subSection-header-auto "
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                role: "heading",
                                                                "aria-level":
                                                                  "4"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subItem.sub_section
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-row py-3 mx-0 mt-4 bg-ltblue text-white rounded-bottom"
                                  },
                                  [
                                    _vm.deleteLinks[vkey] &&
                                    _vm.deleteLinks[vkey].status == "Visible"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "removedv col p-0 text-right mr-3 smaller-font-content"
                                          },
                                          [
                                            _vm.$store.state.buttonState
                                              .quoteSummaryData &&
                                            _vm.$store.state.buttonState
                                              .quoteSummaryData.quote_status !==
                                              "Bound"
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "text-white cursorBox",
                                                    attrs: {
                                                      href:
                                                        "JavaScript:void(0);",
                                                      tabindex: "0",
                                                      "aria-label":
                                                        "remove vehicle"
                                                    },
                                                    on: {
                                                      keydown: function(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        $event.preventDefault()
                                                        $event.stopPropagation()
                                                        return _vm.openRemoveModal(
                                                          "remove-vehicle-modal",
                                                          _vm.deleteLinks[vkey]
                                                            .on_click
                                                        )
                                                      },
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.openRemoveModal(
                                                          "remove-vehicle-modal",
                                                          _vm.deleteLinks[vkey]
                                                            .on_click
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.deleteLinks[vkey]
                                                          .label
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row no-gutters mx-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _vm._l(_vm.pageData.add_buttons, function(
                          ndData,
                          ndKey
                        ) {
                          return ndData.name === "AddVehicle" &&
                            ndData.status !== "Invisible"
                            ? _c(
                                "div",
                                {
                                  key: ndKey + "_add_veh_btm",
                                  staticClass: "form-row m-3"
                                },
                                [
                                  _vm.$store.state.buttonState
                                    .quoteSummaryData &&
                                  _vm.$store.state.buttonState.quoteSummaryData
                                    .quote_status !== "Bound"
                                    ? _c("div", { staticClass: "col-6 pl-2" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "add-button btn btn-outline-success d-inline-block",
                                            attrs: { type: "button" },
                                            on: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                              },
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.addNewRule(
                                                  ndData,
                                                  "Vehicle"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("icon", {
                                              staticClass:
                                                "d-block mr-1 float-left",
                                              attrs: {
                                                name: "plus-circle",
                                                scale: "1.1"
                                              }
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(ndData.label) +
                                                "\n                "
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.blurbs.formbottom.visible
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center mx-auto"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-primary my-0 py-2 w-50",
                                    attrs: { role: "note" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _vm._m(4),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "col d-inline-block my-auto smaller-font-content",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.blurbs.formbottom.content
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getContinueLabelName() != "" && _vm.continueEnabled
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center mx-0 my-3"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-8 text-center" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.submitted($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getContinueLabelName())
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } }),
      _vm._v(" "),
      _vm.$store.state.buttonState.quoteSummaryData &&
      _vm.$store.state.buttonState.quoteSummaryData.quote_status === "Bound"
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "remove-vehicle-modal",
          attrs: {
            "hide-header": "",
            "hide-footer": "",
            "hide-header-close": "",
            "no-enforce-focus": ""
          }
        },
        [
          _c("Trap", [
            _c("div", { staticClass: "remove-confirmation-box" }, [
              _c("div", { staticClass: "remove-modal-message mb-3" }, [
                _c("div", [
                  _vm._v("Are you sure you want to remove this vehicle?")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "remove-modal-sep mt-1 mb-1" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "remove-btn-box" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 remove-btn-cancel remove-cust-btn",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeRemoveModal("remove-vehicle-modal")
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 remove-btn-confirm remove-cust-btn",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.removeRule("remove-vehicle-modal")
                        }
                      }
                    },
                    [_vm._v("\n            Remove")]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "required row mx-0" }, [
      _c("div", { staticClass: "col-12 px-0 text-left" }, [
        _c("span", { staticClass: "star" }, [_vm._v("*")]),
        _vm._v("Required to run carrier quotes.\n                  "),
        _c("hr")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 py-2 pl-2 bg-ltblue text-white rounded-top" },
      [
        _c("div", { attrs: { role: "heading", "aria-level": "2" } }, [
          _vm._v("Review all POLK vehicles with the customer.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 py-2 pl-2 bg-ltblue text-white rounded-top" },
      [
        _c("div", { attrs: { role: "heading", "aria-level": "2" } }, [
          _vm._v("Manually add vehicle(s) to the policy.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51564e18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51564e18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/Auto/RC1/Vehicles.vue
// module id = null
// module chunks = 